import React, { useEffect, useState } from 'react';
import Input from '../../../components/ui/input';
import Button from '../../../components/ui/button';
import Select from '../../../components/ui/select';
import axiosInstance from '../../../utils/axiosInstance';

const PersonalInfoTab = ({ employee, onSave, isEditable = true, isAdmin = false }) => {
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [loadingDepartments, setLoadingDepartments] = useState(true);

  const [formData, setFormData] = useState({
    // Personal Information
    first_name: employee?.first_name || '',
    last_name: employee?.last_name || '',
    email: employee?.email || '',
    phone_number: employee?.phone_number || '',

    // Employment Information
    employee_id: employee?.employee_id || '',
    employee_type: employee?.employee_type || '',
    department: employee.department || '', // Changed to empty string instead of null
    date_of_join: employee?.date_of_join || '',
  });

  const employeeTypeOptions = [
    { value: 'permanent', label: 'Permanent' },
    { value: 'contract', label: 'Contract' },
  ];

  // Fetch departments from backend
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        setLoadingDepartments(true);
        const response = await axiosInstance.get('/departments/getall');
        setDepartments(response.data);

      } catch (error) {
        console.error("Error fetching departments:", error);
      } finally {
        setLoadingDepartments(false);
      }
    };
    fetchDepartments();
  }, []);

  useEffect(() => {
    if (employee) {
      let departmentId = '';

      // Find matching department by name
      if (departments.length > 0 && employee.department) {
        const matchedDept = departments.find(
          dept => dept.name.toLowerCase() === employee.department.toLowerCase()
        );
        departmentId = matchedDept ? matchedDept.id : '';
      }
      console.log("departmentId", departmentId)
      setFormData({
        // Personal Information
        first_name: employee.first_name || '',
        last_name: employee.last_name || '',
        email: employee.email || '',
        phone_number: employee.phone_number || '',

        // Employment Information
        employee_id: employee.employee_id || '',
        employee_type: employee.employee_type || '',
        department: parseInt(departmentId) || '', // Changed to empty string
        date_of_join: employee.date_of_join || '',
      });
    }
  }, [employee]);
  useEffect(()=>{
    let departmentId = '';

      // Find matching department by name
      if (departments.length > 0 && employee.department) {
        const matchedDept = departments.find(
          dept => dept.name.toLowerCase() === employee.department.toLowerCase()
        );
        departmentId = matchedDept ? matchedDept.id : '';
      }
      setFormData({...formData,department:departmentId})
  },[departments,employee])


  useEffect(()=>{
    console.log("depp",formData?.department)
  },[formData])
  const handleInputChange = (field, value) => {
    // Convert department to integer if needed
    if (field === 'department') {
      value = value ? parseInt(value, 10) : '';
    }

    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors?.[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Personal Information validation
    if (!formData?.first_name?.trim()) {
      newErrors.first_name = 'First name is required';
    }

    if (!formData?.last_name?.trim()) {
      newErrors.last_name = 'Last name is required';
    }

    if (!formData?.email?.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(formData?.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (!formData?.phone_number?.trim()) {
      newErrors.phone_number = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.phone_number)) {
      newErrors.phone_number = "Please enter a valid 10-digit phone number";
    }

    // Employment Information validation
    if (!formData?.employee_type?.trim()) {
      newErrors.employee_type = 'Employee type is required';
    }

    if (!formData?.department) {
      newErrors.department = 'Department is required';
    }

    if (!formData?.date_of_join) {
      newErrors.date_of_join = 'Date of joining is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) return;

    setIsLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      onSave?.(formData);
    } finally {
      setIsLoading(false);
    }
  };

  const handleReset = () => {
    setFormData({
      // Personal Information
      first_name: employee?.first_name || '',
      last_name: employee?.last_name || '',
      email: employee?.email || '',
      phone_number: employee?.phone_number || '',

      // Employment Information
      employee_id: employee?.employee_id || '',
      employee_type: employee?.employee_type || '',
      department: employee?.department_id || '', // Changed to empty string
      date_of_join: employee?.date_of_join || '',
    });
    setErrors({});
  };

  return (
    <div className="space-y-6">
      {/* Personal Information */}
      <div>
        <h3 className="text-lg font-semibold text-foreground mb-4">Personal Information</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="First Name"
            type="text"
            value={formData?.first_name}
            onChange={(e) => handleInputChange('first_name', e?.target?.value)}
            error={errors?.first_name}
            required
            disabled={!isEditable}
          />

          <Input
            label="Last Name"
            type="text"
            value={formData?.last_name}
            onChange={(e) => handleInputChange('last_name', e?.target?.value)}
            error={errors?.last_name}
            required
            disabled={!isEditable}
          />

          <Input
            label="Email Address"
            type="email"
            value={formData?.email}
            onChange={(e) => handleInputChange('email', e?.target?.value)}
            error={errors?.email}
            required
            disabled={!isEditable}
          />

          <Input
            label="Phone Number"
            type="tel"
            placeholder="(555) 123-4567"
            value={formData?.phone_number}
            onChange={(e) => handleInputChange('phone_number', e?.target?.value)}
            error={errors?.phone_number}
            required
            disabled={!isEditable}
          />
        </div>
      </div>

      {/* Employment Information */}
      <div>
        <h3 className="text-lg font-semibold text-foreground mb-4">Employment Information</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Employee ID"
            type="text"
            value={formData?.employee_id}
            onChange={(e) => handleInputChange('employee_id', e?.target?.value)}
            disabled={true} // Always disabled as it's a system field
          />

          <Select
            label="Employee Type"
            options={employeeTypeOptions}
            value={formData?.employee_type}
            onChange={(value) => handleInputChange('employee_type', value)}
            error={errors?.employee_type}
            disabled={!isAdmin}
          />

          {loadingDepartments ? (
            <div className="flex items-center justify-center h-10">
              <div className="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
              <span className="ml-2 text-sm text-muted-foreground">Loading departments...</span>
            </div>
          ) : (
            <Select
              label="Department"
              // options={departments.map(dept => ({ 
              //   value: String(dept.id),  // Convert ID to string for consistent comparison
              //   label: dept.name
              // }))}
              value={formData?.department || ''}  // Convert to string for comparison
              onChange={(value) => handleInputChange('department', value)}
              error={errors?.department}
              disabled={!isAdmin}
            />
          )}

          <Input
            label="Date of Joining"
            type="date"
            value={formData?.date_of_join ? formData.date_of_join.split("T")[0] : ""}
            onChange={(e) => handleInputChange('date_of_join', e?.target?.value)}
            error={errors?.date_of_join}
            disabled={!isAdmin}
          />
        </div>
      </div>

      {/* Action Buttons */}
      {isEditable && (
        <div className="flex items-center justify-end space-x-3 pt-6 border-t border-border">
          <Button
            variant="outline"
            onClick={handleReset}
            disabled={isLoading}
          >
            Reset Changes
          </Button>

          <Button
            variant="default"
            onClick={handleSave}
            loading={isLoading}
            iconName="Save"
            iconPosition="left"
          >
            Save Changes
          </Button>
        </div>
      )}
    </div>
  );
};

export default PersonalInfoTab;